import { render, staticRenderFns } from "./LinkButtonImage.vue?vue&type=template&id=a6945e38&scoped=true&lang=pug&"
import script from "./LinkButtonImage.vue?vue&type=script&lang=js&"
export * from "./LinkButtonImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6945e38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6945e38')) {
      api.createRecord('a6945e38', component.options)
    } else {
      api.reload('a6945e38', component.options)
    }
    module.hot.accept("./LinkButtonImage.vue?vue&type=template&id=a6945e38&scoped=true&lang=pug&", function () {
      api.rerender('a6945e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/buttons/LinkButtonImage.vue"
export default component.exports